import { GatewayEntrepriseApi } from "@src/data/entreprise/entreprise.api";
import { entrepriseKeys } from "@src/data/entreprise/hook/entreprise.keys";
import { useQuery } from "@tanstack/react-query";

export function useEntreprise(
  millesime: number | undefined,
  idEntreprise: string
) {
  return useQuery({
    queryKey: entrepriseKeys.detail(idEntreprise),
    queryFn: () =>
      GatewayEntrepriseApi.getEntrepriseById(millesime!, idEntreprise),
    staleTime: Infinity,
    enabled: !!millesime,
  });
}
